import React from 'react'
import styles from "./Calculate.module.css"
import im1 from "../assets/calculate.png"


export default function Calculate() {
  return (
    <>
    <div className={styles.calculdateContainer}>
          <h1 className={styles.calculText2}>CALCULATE THE  SERVICE COST</h1>
          <p className={styles.calculText} style={{fontSize:20}}>Get guaranteed lowest priced quote for your shifting instantly</p>
            <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
                    <button className={styles.calculBtn}>CALCULATE</button>
                    </div>
     
    </div>

     <div className={styles.calculdateContainerMobile}>
      <h1 className={styles.calculText2}>CALCULATE THE  SERVICE COST</h1>
        <div className={styles.calculdateRow}>
            <div className={styles.calculateCol1}>
                <div className={styles.calcul}>
                <img src={im1} alt='' className={styles.calculeImg}/>
              
                </div>
                </div>
                <div className={styles.calculateCol2}>
                    <div className={styles.calcul2}>
                        
                        <p className={styles.calculText}>Get guaranteed lowest priced quote for your shifting instantly</p>
                    </div>
                    <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
                    <button className={styles.calculBtn}>CALCULATE</button>
                    </div>
                </div>

        </div>
    </div>
    </>
  )
}
